import { useState, useEffect } from "react";

// Simple reusable IntersectionObserver hook
// ref: React ref to the DOM node to observe
// options: { root, rootMargin, threshold }
// enabled: boolean to enable/disable observing
export default function useIntersectionObserver(
  ref,
  options = {},
  enabled = true
) {
  const { root = null, rootMargin = "0px", threshold = 0 } = options || {};
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    const node = ref && ref.current;
    if (!node) return undefined;

    let cancelled = false;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!cancelled)
          setIsIntersecting(Boolean(entry && entry.isIntersecting));
      },
      { root, rootMargin, threshold }
    );

    observer.observe(node);

    return () => {
      cancelled = true;
      try {
        observer.disconnect();
      } catch (e) {
        /* ignore */
      }
    };
  }, [ref, root, rootMargin, threshold, enabled]);

  return isIntersecting;
}
